// extracted by mini-css-extract-plugin
module.exports = {"recipe-save-button":"save-button_recipe-save-button__q1crO","default":"save-button_default__SnY5O","contrast":"save-button_contrast__zBMMX","saved":"save-button_saved__08SGv"};